export const promoteSavedQuery = `
    <p>Promoting to a library query will:</p>
    <ul>
        <li>Allow all customers to see this query.</li>
        <li>Prevent non-TRAC users in this org from editing it.</li>
    </ul>
    <p>Please ensure that there is no org-specific information in the name, query, or description.</p>
`;
